import { Box, styled, Typography } from '@mui/material';

export const ActiveDayIndicatorsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 10px;
`;

export const ActiveDayTypography = styled(Typography)`
  margin-right: 4px;
  font-weight: 500;
`;

export const ActiveDayIndicator = styled('div')<{
  $disabled: boolean;
}>(
  ({ theme, $disabled = false }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 1px solid  ${
      $disabled ? theme.palette.divider : theme.palette.primary.main
    };
    border-radius: 50%;
    background-color: ${
      $disabled ? theme.palette.primary.lightest : theme.palette.primary.main
    };
    font-size: 12px;
    color: ${
      $disabled ? theme.palette.brand.disable : theme.palette.primary.lightest
    };
  `,
);
